import { ErrorModule } from './error/error.module';
import { SessionServiceMock } from './session/session.serviceMock';
import { environment } from './../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { EffectsModule } from '@ngrx/effects'

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BefreiungModule } from './befreiung/befreiung.module';
import { SessionService } from './session/session.service';
import { AccountModule } from './account/account.module';
import { appStateStore } from './appState/appStateStore.module';
import { ErrorComponent } from './error/error.component';
import { AppEffects } from './app.effects';
import { AbstractSessionService } from './session/abstract-session.service';
import { AbstractBefreiungService } from './befreiung/shared/services/abstract-befreiung.service';
import { AbstractResetAccountService } from './account/resetAccount/services/abstract-resetAcountService';
import { RequestOptions } from "@angular/http";
import { CustomRequestOptions } from "./shared/customRequestOptions";
import { ResetAccountService } from "./account/resetAccount/services/resetAccount.service";
import { BefreiungService } from "./befreiung/shared/services/befreiungService";
import { BefreiungMockService } from "./befreiung/shared/services/befreiungMockService";
import { ResetAccountMockService } from "./account/resetAccount/services/resetAccountMock.service";
import { SessionGuard } from './session/session.guard';
import {HelpModule} from './help/help.module';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent
  ],
  imports: [
    ErrorModule,
    BrowserModule,
    RouterModule,
    BefreiungModule,
    AppRoutingModule,
    AccountModule,
    HelpModule,
    appStateStore(),
    NgIdleKeepaliveModule.forRoot(),
    EffectsModule.forRoot([ AppEffects])
  ],
  providers: [
    { provide: AbstractSessionService, useClass: (environment.mockServices) ? SessionServiceMock : SessionService},
    { provide: AbstractBefreiungService, useClass: (environment.mockServices) ? BefreiungMockService : BefreiungService},
    { provide: AbstractResetAccountService, useClass: (environment.mockServices) ? ResetAccountMockService : ResetAccountService},
    { provide: RequestOptions, useClass: CustomRequestOptions },
    SessionGuard
    ],
  exports: [
    RouterModule,
    AppRoutingModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts